<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list?.all_data || []"
      show-date
      :date-validation="false"
      date-option-type="datetime"
      :filter-names="filterNames"
      search-label="search"
      :vertical-scroll="false"
      :is-downloading="isDownload"
      :export-options="['csv', 'pdf']"
      per-page="10000"
      @isExport="dowloadFiles"
      @filterOption="onFiltersChange"
    >
      <template v-slot:journey_id="{ index }">
        <div>
          {{ index + 1 }}
        </div>
      </template>
      <template v-slot:origin="{ item }">
        <div>
          <span>{{ item?.route_name }}</span>
          <!-- <span>{{ item?.enter_city }}</span>
          <v-icon>mdi-arrow-right-thin</v-icon>
          <span>{{ item?.exit_city }}</span> -->
        </div>
      </template>
      <template v-slot:departure_time="{ item }">
        <div>
          <span v-if="item.ExitTime">
            {{ item.ExitTime | formatDate }}
          </span>
          <span v-else>-</span>
        </div>
      </template>

      <template v-slot:arrival_time="{ item }">
        <div>
          <span v-if="item.Entry_Time">
            {{ item.Entry_Time | formatDate }}
          </span>
          <span v-else>-</span>
        </div>
      </template>

      <template v-slot:sla_status="{ item }">
        <div>
          <StatusBadge
            :status="item.is_sla_met ? 'SLA_Met' : 'SLA_Not_Met'"
            :text="item.is_sla_met ? 'SLA Met' : 'SLA Not Met'"
          />
        </div>
      </template>

      <template v-slot:departure_compliance="{ item }">
        <div>
          <StatusBadge
            :status="item.is_late_departure ? 'Late_Departure' : 'On_Time'"
            :text="item.is_late_departure ? 'Late Departure' : 'On_Time'"
          />
        </div>
      </template>

      <template #description>
        <div class="d-flex justify-end">
          <v-card :loading="isLoading">
            <v-card-text>
              <div class="info-card">
                <div>
                  <v-icon>mdi-clock-outline</v-icon>
                  <span class="font-weight-bold">Late Departures</span>
                </div>
                <div class="value font-weight-bold">
                  {{ list?.total_late_departures }}
                </div>
                <div class="sub-text text-muted">
                  {{ list?.late_departure_percentage }}% of total departures
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </template>

      <!-- add Filters -->
      <template #addFilters>
        <v-card>
          <v-autocomplete
            v-model="customFilters.vendor_id"
            filled
            dense
            :loading="isVendor"
            :items="vendorList"
            item-text="child_tenant_name"
            item-value="child_tenant"
            :label="$t('select_vendor')"
            clearable
            @change="onVendorChange"
          />
        </v-card>
        <v-card class="allVehicleSelect">
          <v-autocomplete
            v-model="customFilters.route_ids"
            filled
            dense
            :loading="isRoute"
            :items="routeList"
            item-text="name"
            item-value="id"
            :label="$t('select_routes')"
            clearable
            multiple
            @change="onRouteChange"
          >
            <template v-slot:selection="data">
              <span
                v-if="data.index === 0"
                class="selected"
              >
                <span>{{ data.item.name }}</span>
              </span>
              <span
                v-if="data.index === 1"
                class="grey--text text-caption"
              >
                (+{{ customFilters.route_ids.length - 1 }} others)
              </span>
            </template>
          </v-autocomplete>
        </v-card>
        <v-card class="allVehicleSelect">
          <v-autocomplete
            v-model="customFilters.vehicle_ids"
            filled
            dense
            :loading="isVehicle"
            :items="vehicleList"
            item-text="name"
            item-value="id"
            :label="$t('select_vehicles')"
            clearable
            multiple
            @change="fetchData"
          >
            <template v-slot:selection="data">
              <span
                v-if="data.index === 0"
                class="selected"
              >
                <span>{{ data.item.name }}</span>
              </span>
              <span
                v-if="data.index === 1"
                class="grey--text text-caption"
              >
                (+{{ customFilters.vehicle_ids.length - 1 }} others)
              </span>
            </template>
          </v-autocomplete>
        </v-card>
      </template>
      <!-- add Filters -->

      <!-- Action Modals -->
      <!-- <template #actionModals>
        <div class="d-flex"></div>
      </template> -->
      <!-- Action Modals -->
    </ListingLayout>

    <!-- <section>
      <locations-map />
    </section> -->
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
import { debounce } from "lodash";
import jsPDF from "jspdf";
import "jspdf-autotable"; // Import the autoTable plugin
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    StatusBadge: () => import("@/components/base/Status-Badge.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      // module_name: "csmsChargeStations", //vuex module name which define in Store Index
      // permissions: {
      //   view: "locations.view",
      //   create: "locations.create",
      //   edit: "locations.edit",
      //   delete: "locations.delete",
      // },

      //
      filters: {},
      subFilters: {},
      //
      customFilters: {},
      //
      isDownload: false,
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "complianceReports/getLoading",
      meta: "complianceReports/getMeta",
      list: "complianceReports/getList",
      //
      isVendor: "tenantsRelationship/getLoading",
      vendorList: "tenantsRelationship/getList",
      //
      isRoute: "geofence/getLoading",
      routeList: "geofence/getRouteList",
      //
      isVehicle: "vehicles/getIsLoadingVehicles",
      vehicleList: "vehicles/getVehiclesList",
      //
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("journey_id"),
          align: "left",
          sortable: true,
          value: "journey_id",
        },
        {
          text: this.$t("vehicle_id"),
          align: "left",
          sortable: true,
          value: "vehicle_id",
        },
        {
          text: this.$t("reg_no"),
          align: "left",
          sortable: true,
          value: "vehicle_registration_no",
        },
        {
          text: this.$t("driver_name"),
          align: "left",
          sortable: true,
          value: "driver_name",
        },
        {
          // text: "Origin → Destination",
          text: this.$t("lane_name"),
          align: "left",
          sortable: false,
          value: "route_name",
        },
        {
          text: "SLA Target (Hrs)",
          align: "left",
          sortable: true,
          value: "SLA_Target",
        },
        {
          text: "Cutoff Time",
          align: "left",
          sortable: true,
          value: "cutoff_time",
        },
        {
          text: this.$t("departure_time"),
          align: "left",
          sortable: true,
          value: "departure_time",
        },
        {
          text: this.$t("estimate_time_of_arrival"),
          align: "left",
          sortable: true,
          value: "estimate_time_of_arrival",
        },
        {
          text: this.$t("acctual_arrival_time"),
          align: "left",
          sortable: true,
          value: "arrival_time",
        },
        {
          text: this.$t("late_duration"),
          align: "left",
          sortable: true,
          value: "late_duration",
        },

        {
          text: "Actual Time (Hrs)",
          align: "left",
          sortable: true,
          value: "TotalTime",
        },
        {
          text: "SLA Status",
          align: "left",
          sortable: true,
          value: "sla_status",
        },

        {
          text: "Departure Compliance",
          align: "left",
          sortable: true,
          value: "departure_compliance",
        },
      ];
      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },
    // list() {
    //   return this.complianceData?.all_data || [];
    // },

    filterNames() {
      return [];
    },
  },
  watch: {
    "options.tenant_id": {
      handler: function (v) {
        this.customFilters = {};
        this.onTenantChange({ tenant_id: v });
      },
    },
    "options.fleetId": {
      handler: function (v) {
        this.customFilters = {};
        this.onTenantChange({ tenant_id: v });
      },
    },

    options() {
      this.fetchData();
    },
  },

  beforeDestroy() {
    const params = {
      name: "compliance_reports",
      filters: { ...this.options, ...this.customFilters },
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  mounted() {
    setTimeout(() => {
      const tId = this.options?.tenant_id || this.options?.fleetId;
      this.onTenantChange({ tenant_id: tId });
      //
      if (this.$route?.query?.vendor_id) {
        this.customFilters.vendor_id = parseInt(this.$route?.query?.vendor_id);
        this.onVendorChange(this.customFilters.vendor_id);
      }
      if (this.$route?.query?.route_ids) {
        this.customFilters.route_ids = this.$route?.query?.route_ids?.map((r) =>
          parseInt(r)
        );
        this.onRouteChange(this.customFilters.route_ids);
      }
      if (this.$route?.query?.vehicle_ids) {
        this.customFilters.vehicle_ids = this.$route?.query?.vehicle_ids?.map(
          (r) => parseInt(r)
        );
        this.onVehicleChange(this.customFilters.vehicle_ids);
      }
    }, 500);
  },
  methods: {
    fetchData: debounce(async function () {
      const params = {
        ...this.options,
        ...this.customFilters,
        abort_signal: true,
      };
      if (params.vendor_id) {
        if (params.tenant_id) {
          params.tenant_id = params.vendor_id;
        }
        if (params.fleetId) {
          params.fleetId = params.vendor_id;
        }
      }
      await this.$store
        .dispatch("complianceReports/list", params)
        .then((res) => {
          this.getCityName(res);
          if (this.options.page > (this.meta?.lastPage || 1)) {
            this.options.page = 1;
          }
        });
    }, 1500),

    //
    onTenantChange(params) {
      this.getVendorList(params);
      this.getRouteList(params);
      this.getVehicleList(params);
    },
    //
    getVendorList: debounce(async function (params) {
      await this.$store.dispatch("tenantsRelationship/list", {
        parent_tenant_id: params?.tenant_id,
      });
    }, 500),
    getRouteList: debounce(async function (params) {
      await this.$store.dispatch("geofence/routeList", params);
    }, 500),
    getVehicleList: debounce(async function (params) {
      await this.$store.dispatch("vehicles/list", {
        ...params,
        compare_route: true,
      });
    }, 500),
    //
    onVendorChange(v) {
      delete this.customFilters.route_ids;
      delete this.customFilters.vehicle_ids;

      const params = { tenant_id: v };
      this.getRouteList(params);
      this.getVehicleList(params);
      this.fetchData();
    },
    onRouteChange(v) {
      delete this.customFilters.vehicle_ids;
      const params = { route_ids: v, tenant_id: this.customFilters.vendor_id };
      this.getVehicleList(params);
      this.fetchData();
    },
    //
    async getCityName() {
      for (const el of this.list?.all_data) {
        const startCity = await this.reverseGeocode(el.EntryLat, el.EntryLon);
        const endCity = await this.reverseGeocode(el.ExitLat, el.ExitLon);
        el.enter_city = startCity;
        el.exit_city = endCity;
      }
    },
    async reverseGeocode(lat, lng) {
      const apiKey = process.env.VUE_APP_GOOGLE_MAP_KEY; // 🔐 Replace securely
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

      try {
        const response = await fetch(url);
        const data = await response.json();
        if (data.status === "OK") {
          const result = data.results.find(
            (r) =>
              r.types.includes("locality") ||
              r.types.includes("administrative_area_level_2")
          );
          const cName =
            result?.formatted_address ||
            data.results[0]?.formatted_address ||
            "-";
          return cName.split(",")[0];
        } else {
          return "-";
        }
      } catch (error) {
        return "-";
      }
    },
    dowloadFiles(v) {
      if (v === "csv") this.downloadCSV("Compliance Report");
      else if (v === "pdf") this.downloadPDF("Compliance Report");
    },
    downloadCSV(fName = "File_name") {
      this.isDownload = true;
      const csv = this.convertToCSV(this._headers, this.list?.all_data);
      const blob = new Blob(["\uFEFF" + csv], {
        type: "text/csv;charset=utf-8;",
      }); // With BOM
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `${fName}.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.isDownload = false;
    },
    convertToCSV(head, objArray) {
      let summary = [];
      for (const key in this.list) {
        if (key !== "all_data") {
          summary.push(`${key},${this.list[key]}`);
        }
      }
      summary = summary.join("\r\n");

      const summarySection = "Summary Data\r\n" + summary + "\r\n\r\n";
      const headerRow = head
        .map((h) =>
          h.value === "origin"
            ? "Origin → Destination"
            : h.value.replace(/_/g, " ")
        )
        .join(",");
      const rows = objArray.map((row, index) =>
        head
          .map((h) => {
            if (h.value === "journey_id") {
              // Replace trip_id column with 1-based index
              return escape(index + 1);
            } else if (h.value === "origin") {
              return `${row.enter_city} → ${row.exit_city}`;
            } else if (h.value === "departure_time") {
              return `${row.ExitTime}`;
            } else if (h.value === "arrival_time") {
              return `${row.Entry_Time}`;
            } else if (h.value === "sla_status") {
              return `${row.is_sla_met ? "SLA Met" : "SLA not Met"}`;
            } else if (h.value === "departure_compliance") {
              return `${row.is_late_departure ? "Late Departure" : "On Time"}`;
            } else {
              return row[h.value] ?? "";
            }
          })
          .join(",")
      );
      const tableSection = headerRow + "\r\n" + rows.join("\r\n");
      return summarySection + tableSection;
    },
    downloadPDF(fName = "File_Name") {
      this.isDownload = true;

      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "px",
        format: "a4",
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      // Add the logo (Base64 image)
      if (this.authUser.isAdmin) {
        pdf.addImage(this.pdfLogo, "PNG", pageWidth - 70, 20, 50, 30);
      } else {
        const bLogo = this.authUser?.business_logo;
        pdf.addImage(bLogo, "PNG", pageWidth - 70, 20, 50, 50);
      }

      // Add Report Name
      pdf.setFontSize(18);
      pdf.text(fName, 20, 40);

      // Draw static card-like box
      const boxX = 20;
      const boxY = 60;
      const boxWidth = 150;
      const boxHeight = 80;
      const { late_departure_percentage, total_late_departures } = this.list;

      pdf.setDrawColor(200); // Border color
      pdf.setFillColor(255, 255, 255); // White background
      pdf.rect(boxX, boxY, boxWidth, boxHeight, "FD"); // Draw filled rectangle with border

      // Icon (clock symbol using emoji or small text)
      pdf.setFontSize(12);
      pdf.text("Late Departures", boxX + 10, boxY + 20);

      // Value
      pdf.setFontSize(24);
      pdf.setTextColor(50, 50, 50);
      pdf.text(`${total_late_departures}`, boxX + 10, boxY + 45);

      // Subtext
      pdf.setFontSize(10);
      pdf.setTextColor(100, 150, 100);
      pdf.text(
        `${late_departure_percentage}% of total departures`,
        boxX + 10,
        boxY + 60
      );

      const head = this._headers;
      const headValue = head.map((r) => r.value);
      const headers = [head.map((r) => r.text)];

      const rows = this.list?.all_data;
      const arr = [];
      rows.forEach((el, i) => {
        arr.push(
          headValue.map((r) => {
            if (r == "journey_id") {
              return i + 1;
            } else if (r == "origin") {
              return `${el.route_name}`;
            } else if (r == "departure_time") {
              return `${el.ExitTime} `;
            } else if (r == "arrival_time") {
              return `${el.Entry_Time} `;
            } else if (r == "sla_status") {
              return `${el.is_sla_met ? "SLA Met" : "SLA not Met"} `;
            } else if (r == "departure_compliance") {
              return `${el.is_late_departure ? "Late Departure" : "On Time"} `;
            } else return el[r];
          })
        );
      });

      pdf.autoTable({
        head: headers,
        body: arr,
        startY: 150,
      });

      pdf.save(`${fName}.pdf`);
      this.isDownload = false;
    },
  },
};
</script>
<style lang="sass" scoped>
:deep .SLA_Met
  background: #D7FBE8 !important
  color: #027A48 !important
  // &::before
  //   background: red

:deep .SLA_Not_Met
  background: #FFB6C1 !important
  color: #8B0000 !important

:deep .On_Time
  background: #ADD8E6 !important
  color: #00008B  !important

:deep .Late_Departure
  background: #FFE4C4  !important
  color: #D2691E   !important

:deep .v-data-table__expanded
  background: #e6f9ec


.info-card
  display: flex
  flex-direction: column
  gap: 1rem
  i
    margin-right: 0.5rem
  .value
    margin-left: 5px
    font-size: 2rem
  .sub-text
    font-size: 0.85rem
</style>
